import React from "react";
import "./login.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { login } from "../schemas";
import UserServices from "../../UserServices/UserServices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import { NoteState } from "../../context/notes/NoteState";
import logo from "../../../src/icons/logo.png";


export default function Login() {
  const { dispatch: ctxDispatch } = useContext(NoteState);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const initialValues = {
    email: "",
    password: "",
  };
  const Login = async (values) => {
    try {
      setLoading(true);
      const response = await UserServices.Login(values);
      if (response.status === 200) {
        const branchId = response.data.user.branch_id || "";
        ctxDispatch({
          type: "LOGIN",
          accessToken: response.data.access_token,
          branchId: branchId,
          UId: response.data.user.id,
          role: response.data.user.role,
        });
        setLoading(false);
        if (response.data.user.role === "7") {
          navigate("/cafe-dashboard");
        } else if (response.data.user.role === "12") {
          navigate("/hr-dashboard");
        } else if (response.data.user.role === "5") {
          navigate("/finance-dashboard");
        } else if (
          response.data.user.role === "1" ||
          response.data.user.role === "3" ||
          response.data.user.role === "4"
        ) {
          navigate("/dashboard");
        } else {
          navigate("/employee-dashboard");
        }
      }
    } catch (err) {
      setLoading(false);
      if (err.response.status === 401) {
        toast.error("Wrong email or password!", { position: "top-center" });
      } else if (err.response.status === 422) {
        toast.error("Unproccessable content!", { position: "top-center" });
      }
    }
  };
  //validation........................................................................................
  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: login,
      onSubmit: (values) => {
        Login(values);
      },
    });
  return (
    <div className="login-page">
       <ToastContainer />
      <div className="pen-title">
        <img src={logo} alt="" />
        <br />
        <span>DASHBOARD LOGIN</span>
      </div>
      <div className="container">
        <div className="card">
          <h1 className="title">Login</h1>
          <form onSubmit={handleSubmit}>
          <label htmlFor="#{email}" className="lable">Email</label>
            <div className="input-container">
              <input
                placeholder=""
                type="email"
                id="#{email}"
                name="email"
                autoComplete="off"
                value={values.email || ""}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div className="bar" />
              {errors.email && touched.email ? (
                <p className="text-danger">{errors.email}</p>
              ) : null}
            </div>
            <label htmlFor="#{password}" className="lable">Password</label>
            <div className="input-container">
              <input
                type="password"
                placeholder=""
                id="#{password}"
                name="password"
                autoComplete="off"
                value={values.password || ""}
                onChange={handleChange}
                onBlur={handleBlur}
              />
             
              <div className="bar" />
              {errors.password && touched.password ? (
                <p className="text-danger">{errors.password}</p>
              ) : null}
            </div>
            <div className="button-container">
              <button type="submit">
                <span>Login</span>
              </button>
            </div>
           
          </form>
        </div>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}


